var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4541 7.79213C16.4293 7.73862 16.3948 7.68935 16.3517 7.64703C16.3515 7.64681 16.3512 7.64659 16.351 7.64637L13.5796 4.919C13.381 4.7235 13.0599 4.7235 12.8612 4.919C12.6626 5.1145 12.6626 5.4305 12.8612 5.626L14.7655 7.5L4.90698 7.5C4.62602 7.5 4.39892 7.724 4.39892 8C4.39892 8.276 4.62602 8.5 4.90698 8.5L14.7654 8.5L12.8612 10.3735C12.6626 10.569 12.6626 10.885 12.8612 11.0805C13.0599 11.276 13.381 11.276 13.5796 11.0805L16.3505 8.35413M16.3522 8.35244C16.3948 8.31051 16.4289 8.26181 16.4536 8.20892C16.4834 8.14534 16.5 8.07457 16.5 8C16.5 7.92585 16.4836 7.85545 16.4541 7.79213M1.51463 16C0.812997 16 0.241933 15.438 0.241933 14.7475L0.241934 1.252C0.241934 0.561999 0.812998 -6.74816e-07 1.51464 -6.44634e-07L8.37097 -3.49691e-07C8.65142 -3.37627e-07 8.87903 0.224 8.87903 0.5C8.87903 0.776 8.65142 1 8.37097 1L1.51464 0.999999C1.37339 0.999999 1.25806 1.113 1.25806 1.252L1.25806 14.7475C1.25806 14.8865 1.37339 15 1.51463 15L8.37097 15C8.65142 15 8.87903 15.2235 8.87903 15.5C8.87903 15.7765 8.65142 16 8.37097 16L1.51463 16Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4541 7.79213C16.4293 7.73862 16.3948 7.68935 16.3517 7.64703C16.3515 7.64681 16.3512 7.64659 16.351 7.64637L13.5796 4.919C13.381 4.7235 13.0599 4.7235 12.8612 4.919C12.6626 5.1145 12.6626 5.4305 12.8612 5.626L14.7655 7.5L4.90698 7.5C4.62602 7.5 4.39892 7.724 4.39892 8C4.39892 8.276 4.62602 8.5 4.90698 8.5L14.7654 8.5L12.8612 10.3735C12.6626 10.569 12.6626 10.885 12.8612 11.0805C13.0599 11.276 13.381 11.276 13.5796 11.0805L16.3505 8.35413M16.3522 8.35244C16.3948 8.31051 16.4289 8.26181 16.4536 8.20892C16.4834 8.14534 16.5 8.07457 16.5 8C16.5 7.92585 16.4836 7.85545 16.4541 7.79213M1.51463 16C0.812997 16 0.241933 15.438 0.241933 14.7475L0.241934 1.252C0.241934 0.561999 0.812998 -6.74816e-07 1.51464 -6.44634e-07L8.37097 -3.49691e-07C8.65142 -3.37627e-07 8.87903 0.224 8.87903 0.5C8.87903 0.776 8.65142 1 8.37097 1L1.51464 0.999999C1.37339 0.999999 1.25806 1.113 1.25806 1.252L1.25806 14.7475C1.25806 14.8865 1.37339 15 1.51463 15L8.37097 15C8.65142 15 8.87903 15.2235 8.87903 15.5C8.87903 15.7765 8.65142 16 8.37097 16L1.51463 16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    width: 16,
    height: 16.2581,
    transform: "rotate(90 16.5 0)",
    fill: "#3E3F42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.07eec7715563fe9a98219e2b78d05baf.svg";
export { ForwardRef as ReactComponent };